import React from 'react';
import { BookOpen, FileText, Sparkles, Layers } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <BookOpen className="text-accent" size={24} data-id="element-220" />,
    text: '6 Tomos + 6 Bonos + 5 Cuadernillos'
  }, {
    icon: <FileText className="text-accent" size={24} data-id="element-221" />,
    text: '+800 actividades imprimibles'
  }, {
    icon: <Sparkles className="text-accent" size={24} data-id="element-222" />,
    text: '100% material visual y aplicable'
  }, {
    icon: <Layers className="text-accent" size={24} data-id="element-223" />,
    text: 'Organizado en 3 franjas etarias'
  }];
  return <div className="text-ink py-5 border-y border-ink/10 bg-surface/60" data-id="element-224">
      <div className="max-w-6xl mx-auto px-3" data-id="element-225">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-accent/20" data-id="element-226">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center justify-center gap-2" data-id="element-227">
              {stat.icon}
              <span className="font-medium text-xs md:text-sm text-ink/80" data-id="element-228">
                {stat.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}